import styled from 'styled-components';

const base = `
  padding: 6px 19px;
  border: 0;
  outline: none;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  line-height: 25px;
  transition: all 0.2s ease;
`;

const defaultButton = styled.button`
  ${base};
  background-color: ${(props) => props.theme.colors.primary};
  color: white;

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryBright};
  }

  &:disabled {
    background-color: ${(props) => props.theme.colors.grey};
    color: #ccc;
    cursor: not-allowed;
  }
`;

interface SecondaryButtonProps {
  greenText?: boolean;
  whiteBackground?: boolean;
}

export const SecondaryButton = styled.button<SecondaryButtonProps>`
  ${base};

  background-color: ${(props) => (props.whiteBackground ? 'white' : props.theme.colors.grey)};
  color: ${(props) => (props.greenText ? props.theme.colors.primary : 'black')};

  &:hover {
    background-color: ${(props) => props.theme.colors.greyDark};
  }
`;

export const ButtonLink = styled.a`
  ${base};
  text-decoration: none;

  background-color: ${(props) => props.theme.colors.primary};
  color: white;

  &.red {
    background-color: ${(props) => props.theme.colors.error};
  }

  &:hover {
    background-color: ${(props) => props.theme.colors.primaryBright};
  }
`;

export default defaultButton;
